import axios from 'axios'
import { navigateToLogout } from './navigation';

const BaseUrl = process.env.REACT_APP_BASE_URL;

export const createEntity = async (form) => {
    const response = await putAsync('/Entity', form);
    return response?.data;
}
export const editEntity = async (form) => {
    const response = await postAsync('/Entity', form);
    return response?.data;
}
export const getEntityForm = async () => {
    const response = await getAsync('/Entity/Form');
    return response?.data;
}
export const getEntity = async (id) => {
    const response = await getAsync('/Entity?id=' + id);
    return response?.data;
}
export const getEntities = async (page, count, term,) => {
    const response = await getAsync('/Entities?page=' + page + '&count=' + count + '&term=' + term);
    return response?.data;
}


export const getRules = async (entityId, page, count, term,) => {
    const response = await getAsync('/Rules?entityId=' + entityId + '&page=' + page + '&count=' + count + '&term=' + term);
    return response?.data;
}
export const getRule = async (id) => {
    const response = await getAsync('/Rule?id=' + id);
    return response?.data;
}





export const getBusinessPartnerForm = async (entityId, page, count, term, types) => {
    const response = await getAsync('/BusinessPartner/Form');
    return response?.data;
}
export const getBusinessPartners = async (entityId, page, count, term, types) => {
    const response = await getAsync('/BusinessPartners?entityId=' + entityId + '&page=' + page + '&count=' + count + '&term=' + term + '&businessPartnerTypes=' + types);
    return response?.data;
}
export const getBusinessPartner = async (id) => {
    const response = await getAsync('/BusinessPartner?id=' + id);
    return response?.data;
}
export const deleteBusinessPartner = async (id) => {
    const response = await deleteAsync('/BusinessPartner?id=' + id);
    return response?.data;
};
export const createBusinessPartner = async (entityId, form) => {
    try {
        const response = await axios.put(BaseUrl + '/BusinessPartner?entityId=' + entityId, form, await getHeaders());
        return response?.data;
    } catch (error) {
        processError(error);
    }
};
export const editBusinessPartner = async (entityId, form) => {
    try {
        const response = await axios.post(BaseUrl + '/BusinessPartner?entityId=' + entityId, form, await getHeaders());
        return response?.data;
    } catch (error) {
        processError(error);
    }
};

export const getUsers = async (entityId, page, count, term) => {
    const response = await getAsync('/Users?entityId=' + entityId + '&page=' + page + '&count=' + count + '&term=' + term);
    return response?.data;
};
export const getUser = async (entityId, id) => {
    const response = await getAsync('/User?entityId='+ entityId + '&id=' + id);
    return response?.data;
};
export const createUser = async (entityId, form) => {
    try {
        const response = await axios.put(BaseUrl + '/User?entityId=' + entityId, form, await getHeaders());
        return response?.data;
    } catch (error) {
        processError(error);
    }
};
export const editUser = async (entityId, form) => {
    try {
        const response = await axios.post(BaseUrl + '/User?entityId=' + entityId, form, await getHeaders());
        return response?.data;
    } catch (error) {
        processError(error);
    }
};
export const getDiscoverForm = async () => {
    const response = await getAsync('/Discover/Form');
    return response?.data;
};
export const getAssets = async (entityId, page, count, term, assetOwners, assetClasses, assetOwnerTypes) => {
    const response = await getAsync('/Assets?entityId=' + entityId + '&assetOwners=' + assetOwners + '&page=' + page + '&count=' + count + '&term=' + term + '&assetClasses=' + assetClasses + '&assetOwnerTypes=' + assetOwnerTypes);
    return response?.data;
};
export const getAsset = async (id) => {
    const response = await getAsync('/Asset?id=' + id);
    return response?.data;
};
export const deleteAsset = async (id) => {
    const response = await deleteAsync('/Asset?id=' + id);
    return response?.data;
};
export const getAssetTitles = async (id) => {
    const response = await getAsync('/Asset/Titles?id=' + id);
    return response?.data;
};
export const getAssetTitleForm = async (id) => {
    const response = await getAsync('/Asset/Title/Form');
    return response?.data;
};

export const uploadAssetTitle = async (id, state, titleNumber, filename, bytes, fileType) => {
    const form = new FormData();
    form.append('file', new Blob([bytes], { type: fileType }), filename);
    form.append('data', JSON.stringify({ id: id, state: state, titleNumber: titleNumber }));

    const response = await putAsync('/Asset/Title', form);
    return response?.data;
};
export const importAssets = async (entityId, filename, bytes, fileType) => {
    const form = new FormData();
    form.append('file', new Blob([bytes], { type: fileType }), filename);
    form.append('data', JSON.stringify({ entityId: entityId }));

    const response = await putAsync('/Asset/Import', form);
    return response?.data;
};

export const editEntityDocumentLogo = async (entityId, filename, bytes, fileType) => {
    const form = new FormData();
    form.append('file', new Blob([bytes], { type: fileType }), filename);
    form.append('data', JSON.stringify({ entityId: Number(entityId) }));

    const response = await putAsync('/Entity/DocumentLogo', form);
    return response?.data;
};
export const getEntityDocumentLogo = async (entityId) => {
    const response = await getAsync('/Entity/DocumentLogo?entityId=' + entityId);
    return response?.data;
};
export const createAsset = async (form) => {
    const response = await putAsync('/Asset', form)
    return response?.data;
};
export const editAsset = async (form) => {
    const response = await postAsync('/Asset', form)
    return response?.data;
};
export const getAssetForm = async (entityId) => {
    const response = await getAsync('/Asset/Form?entityId=' + entityId);
     return response?.data;
};

export const getTransactions = async (dealerId, page, count, term, statuses) => {
    const response = await getAsync('/Transactions?dealerId=' + dealerId + '&page=' + page + '&count=' + count + '&term=' + term + '&statuses=' + statuses);
    return response?.data;
};
export const deleteTransaction = async (id) => {
    const response = await deleteAsync('/Transaction?id=' + id);
    return response?.data;
};


export const getMetrics = async (dealerId, daysBack) => {
    const response = await getAsync('/Metrics?dealerId=' + dealerId + '&daysBack=' + daysBack);
    return response?.data;
};
export const GetMetricPercentMatches = async (dealerId) => {
    const response = await getAsync('/Metric/PercentMatches?dealerId=' + dealerId);
    return response?.data;
};
export const getTransactionMatchesForAssets = async (id) => {
    const response = await getAsync('/Transaction/Match?assetId=' + id);
    return response?.data;
};
export const getTransactionMatches = async (dealer, form) => {
    try {
        const response = await axios.post(BaseUrl + '/Transaction/Match?ownerId=' + dealer, form, await getHeaders());
        return response?.data;
    } catch (error) {
        processError(error);
    }
};


export const getTransactionDocuments = async (transactionId) => {
    const response = await getAsync('/Transaction/Documents?transactionId=' + transactionId);
    return response?.data;
};
export const getEntityDocumentLogoUrl = async (entityId, inline) => {
    const accessToken = await getAccessToken();
    return BaseUrl + '/Entity/DocumentLogo/?entityId=' + entityId + "&inline=" + (inline ? 'true' : 'false') + "&accessToken=" + accessToken;
};
export const getAssetTitleUrl = async (id, inline) => {
    const accessToken = await getAccessToken();
    return BaseUrl + '/Asset/Title?id=' + id + "&inline=" + (inline ? 'true' : 'false') + "&accessToken=" + accessToken;
};
export const getTransactionLetterUrl = async (id, inline) => {
    const accessToken = await getAccessToken();
    return BaseUrl + '/Transaction/Document/TransactionLetter?transactionId=' + id + "&inline=" + (inline ? 'true' : 'false') + "&accessToken=" + accessToken;
};
export const getTitleApplicationForTransactionUrl = async (id, inline) => {
    const accessToken = await getAccessToken();
    return BaseUrl + '/Transaction/Document/TitleApplication?transactionId=' + id + "&inline=" + (inline ? 'true' : 'false') + "&accessToken=" + accessToken;
};
export const getBillOfSaleForTransactionUrl = async (id, inline) => {
    const accessToken = await getAccessToken();
    return BaseUrl + '/Transaction/Document/BillOfSale?transactionId=' + id + "&inline=" + (inline ? 'true' : 'false') + "&accessToken=" + accessToken;
};
export const getSaleTitleDocumentForTransactionUrl = async (id, inline) => {
    const accessToken = await getAccessToken();
    return BaseUrl + '/Transaction/Document/SaleTitleDocument?transactionId=' + id + "&inline=" + (inline ? 'true' : 'false') + "&accessToken=" + accessToken;
};
export const getTransactionDocumentUrl = async (id, transactionId, inline) => {
    const accessToken = await getAccessToken();
    return BaseUrl + '/Transaction/Document?id=' + id + '&transactionId=' + transactionId + "&inline=" + (inline ? 'true' : 'false') + "&accessToken=" + accessToken;
};
export const getTransactionForm = async (stateId) => {
    const response = await getAsync('/Transaction/Form?stateId=' + stateId);
    return response?.data;
};
export const getTransaction = async (id) => {
    const response = await getAsync('/Transaction?id=' + id);
    return response?.data;
};
export const updateTransactionStatus = async (id, form) => {
    const response = await postAsync('/Transaction?id=' + id, form);
    return response?.data;
};
export const createTransaction = async (entityId, dealer, form) => {
    try {
        const response = await axios.put(BaseUrl + '/Transaction?entityId=' + entityId + '&ownerId=' + dealer, form, await getHeaders());
        return response?.data;
    } catch (error) {
        processError(error);
    }
};
export const editTransaction = async (dealer, form) => {
    try {
        const response = await axios.post(BaseUrl + '/Transaction?ownerId=' + dealer, form, await getHeaders());
        return response?.data;
    } catch (error) {
        processError(error);
    }
};

export const getRuleForm = async () => {
    const response = await getAsync('/Rule/Form');
    return response?.data;
};
export const editRule = async (form) => {
    const response = await postAsync('/Rule', form);
    return response?.data;
};

export const getRoles = async (entityId) => {
    const response = await getAsync('/Roles?entityId=' + entityId);
    return response?.data;
};



export const getMe = async () => {
    const response = await getAsync('/Me');
    return response?.data;
};




let fetchAccessTokenFunc = null;
export const setFetchAccessTokenFunc = (func) => {
    fetchAccessTokenFunc = func;
}
const getAsync = async (url) => {
    try {
        const response = await axios.get(BaseUrl + url, await getHeaders());
        return response
    } catch (error) {
        processError(error);
    }
}
const putAsync = async (url, form) => {
    try {
        const response = await axios.put(BaseUrl + url, form, await getHeaders());
        return response;
    } catch (error) {
        processError(error);
    }
}
const postAsync = async (url, form) => {
    try {
        const response = await axios.post(BaseUrl + url, form, await getHeaders());
        return response;
    } catch (error) {
        processError(error);
    }
}
const deleteAsync = async (url) => {
    try {
        const response = await axios.delete(BaseUrl + url, await getHeaders());
        return response
    } catch (error) {
        processError(error);
    }
}

const getHeaders = async () => {
    const accessToken = await getAccessToken();
    return {
        headers: {
            Authorization: 'Bearer ' + accessToken,
            'perfect-dark': '7435919f-9e5f-48a7-914d-b3f154398644'
        }
    }
}
const processError = (error) => {
    console.log(error)
    if (error?.response?.status === 401)
        navigateToLogout();
}
const getAccessToken = async () => {
    try {
        const token = await fetchAccessTokenFunc({ audience: "nvcomputers.com" });
        return token;
    } catch (err) {
        console.error("Failed to get token:", err);
    }
    return null;
};
